import React from 'react';
import PropTypes from 'prop-types';

import FormRoom from './FormRoom';

import useCreateRoom from '../hooks/useCreateRoom';

function CreateRoom({ cancelClick }) {
  const hook = useCreateRoom(cancelClick);
  return <FormRoom hook={hook} />
}

CreateRoom.propTypes = {
  cancelClick: PropTypes.func
}

export default CreateRoom;
